import * as React from 'react';
import Dropdown from '../../Dropdown/Dropdown';
import type { EnumFilterItem, FilterItem } from '../../../../types/Filter';
import { AddFilterDropdown } from '../AddFilter/AddFilter';
import DropdownMultipleFilter from '../../DropdownMultipleFilter/DropdownMultipleFilter';
import type { OnFilterChangeHandler } from '../types';
import DeleteFilterButton from './DeleteFilterButton';
import Styles from './filter-views.module.scss';

type Props = {
    filterItem: EnumFilterItem;
    availableFilters: FilterItem[];
    onChange: OnFilterChangeHandler;
};

const DROPDOWN_ITEMS = [
    { name: 'One of', value: 'in' },
    { name: 'Is not one of', value: 'nin' },
    { name: 'Is all', value: 'all' }
];

const EnumFilterView = (props: Props) => {
    const { filterItem } = props;

    const operatorDropdownItems = DROPDOWN_ITEMS.filter((item) => (item.value === 'all' ? filterItem.isList : true));
    const selectedOperatorItem = operatorDropdownItems.find((item) => item.value === filterItem.operator);

    return (
        <div className={Styles['filter-view']}>
            <AddFilterDropdown
                availableFilters={props.availableFilters}
                value={filterItem}
                onAdd={(filterItem) => filterItem !== props.filterItem && props.onChange(filterItem)}
            />
            <Dropdown
                options={operatorDropdownItems}
                value={filterItem.operator}
                menuClassName={Styles['filter-view-dropdown-tooltip']}
                className={Styles.control}
                onChange={(operator) => {
                    if (operator !== filterItem.operator) {
                        props.onChange({
                            ...filterItem,
                            operator: operator as EnumFilterItem['operator']
                        });
                    }
                }}
                dataTip={selectedOperatorItem?.name}
                dataTipOverflow
            />
            <DropdownMultipleFilter
                options={filterItem.options}
                value={filterItem.values ?? []}
                placeholder="Select options"
                sameWidth
                className={Styles.control}
                onChange={(values) => {
                    props.onChange({
                        ...filterItem,
                        values
                    });
                }}
            />
            <DeleteFilterButton {...props} />
        </div>
    );
};

export default EnumFilterView;
